@let investment = investmentInput();
@defer (when initialCalcDone()) {
    <div
        class="tags-container"
        #tagsContainer
    >
        @if (investment.isDip && availableTags['dip'].visible && availableTags['dip'].exists) {
            <liberro-badge
                data-cy="investment-badge-dip"
                variant="success"
                [label]="('badge.dip' | translate) | trimTagNamePipe:trimTagNames()"
                nz-tooltip
                autoCloseOnScroll
                [nzTooltipTitle]="investmentDipTooltip"
                nzTooltipOverlayClassName="lean"
                [nzTooltipVisible]="dipTooltipVisible()"
                (nzTooltipVisibleChange)="dipTooltipToggle($event)"
                (click)="dipTooltipToggle(!dipTooltipVisible(), $event)"
            ></liberro-badge>
            <ng-template #investmentDipTooltip>
                <liberro-tooltip-content>
                    <div tooltipContent>
                        {{ ('investmentTile.' + (investment.portfolioType === 'PORTFOLIO_MANAGEMENT' ? 'portfolioDipTooltip' : 'strategyDipTooltip')) | translate }}
                    </div>
                </liberro-tooltip-content>
            </ng-template>
        }
        @if (investment.isEfektika && availableTags['efektika'].visible && availableTags['efektika'].exists) {
            <liberro-badge
                data-cy="investment-badge-efektika"
                variant="magenta"
                [label]="('badge.efektika' | translate) | trimTagNamePipe:trimTagNames()"
                nz-tooltip
                autoCloseOnScroll
                [nzTooltipTitle]="investmentEfektikaTooltip"
                nzTooltipOverlayClassName="lean"
                [nzTooltipVisible]="efektikaTooltipVisible()"
                (nzTooltipVisibleChange)="efektikaTooltipToggle($event)"
                (click)="efektikaTooltipToggle(!efektikaTooltipVisible(), $event)"
            ></liberro-badge>
            <ng-template #investmentEfektikaTooltip>
                <liberro-tooltip-content>
                    <div tooltipContent>
                        {{ 'investmentTile.strategyEfektikaTooltip' | translate }}
                    </div>
                </liberro-tooltip-content>
            </ng-template>
        }
        @if (investment.exclusive && availableTags['exclusive'].visible && availableTags['exclusive'].exists) {
            <liberro-badge
                data-cy="investment-badge-exclusive"
                variant="exclusive"
                [label]="exclusiveBadgeLabel()"
                nz-tooltip
                autoCloseOnScroll
                [nzTooltipTitle]="investmentExclusiveTooltip"
                nzTooltipOverlayClassName="lean"
                [nzTooltipVisible]="exclusiveTooltipVisible()"
                (nzTooltipVisibleChange)="exclusiveTooltipToggle($event)"
                (click)="exclusiveTooltipToggle(!exclusiveTooltipVisible(), $event)"
            ></liberro-badge>
            <ng-template #investmentExclusiveTooltip>
                <liberro-tooltip-content>
                    <div tooltipContent>
                        {{ (investment.portfolioType === 'PORTFOLIO_MANAGEMENT' ?
                            'investmentTile.exclusiveTooltip.basePortfolio' :
                            'investmentTile.exclusiveTooltip.baseStrategy'
                           ) | translate
                        }}
                        @if (exclusiveStatus === 'IN_PROGRESS') {
                            {{ 'investmentTile.exclusiveTooltip.IN_PROGRESS' | translate:({
                                remainingAmount: (investment.exclusiveThreshold?.remainingAmount ?? 0 | price),
                                daysRemaining: (investment.exclusiveThreshold?.daysRemaining ?? 0 | translateTimeUnit: 'day'),
                            })}}
                        } @else if (exclusiveStatus === 'LIQUIDATION') {
                            {{ 'investmentTile.exclusiveTooltip.LIQUIDATION' | translate }}
                        }
                        {{
                            isInDetail() ?
                            '' :
                            ('investmentTile.exclusiveTooltip.' + (investment.portfolioType === 'PORTFOLIO_MANAGEMENT' ? 'moreInDetailPortfolio' : 'moreInDetailStrategy')) | translate
                        }}
                    </div>
                </liberro-tooltip-content>
            </ng-template>
        }

        @if (hiddenTagsCount() > 0) {
            <liberro-badge
                data-cy="investment-badge-hidden-count"
                variant="aquamarine"
                [label]="'+' + hiddenTagsCount()"
                nz-tooltip
                autoCloseOnScroll
                nzTooltipOverlayClassName="lean"
                [nzTooltipTitle]="hiddenTagsTooltip"
                [nzTooltipVisible]="hiddenTagsTooltipVisible()"
                (nzTooltipVisibleChange)="hiddenTagsTooltipToggle($event)"
                (click)="hiddenTagsTooltipToggle(!hiddenTagsTooltipVisible(), $event)"
            ></liberro-badge>
            <ng-template #hiddenTagsTooltip>
                <liberro-tooltip-content>
                    <div tooltipContent>
                          {{ hiddenTags() }}
                    </div>
                </liberro-tooltip-content>
            </ng-template>
        }

    </div>
}
